/* eslint-disable react/no-array-index-key */
import React, { Fragment } from 'react';
import GMapSimpleMarker from '../../../../helpers/g-map-simple-marker';

function createSkeleton() {
  return (
    <h1 className='text-center'>
      <br />
      <br />
      <img
        src='https://www.mundigea.com.ar/buscarxpaquetes/assets/img/loader2.gif'
        alt=''
        className='img-responsive'
        style={{ height: 110, marginBottom: 42 }}
      />
    </h1>
  );
}

function createElement(data) {
  const elements = {
    politicasDeCancelacion: [],
    condicionesUso: [],
    serviciosIncluidos: [],
    servicios: [],
    serviciosEspeciales: [],
    ingresos: [],
    infoGeneralItems: [],
    infoGeneralITexto: [],
    ubicacion: {
      longitud: null,
      latitud: null,
    },
  };
  data.forEach((element) => {
    switch (element.itemProducto.descripcion) {
      case 'condiciones-uso':
        elements.condicionesUso = elements.condicionesUso.concat(
          <div key={element.id} className='service'>
            <div className='background color-dinamico-fondo'>
              <i className={`${element.itemProducto.valor}`} />
            </div>
            <div className='service-label'>
              {element.valor}
            </div>
          </div>,
        );
        break;
      case 'servicios-incluidos':
        elements.serviciosIncluidos = elements.serviciosIncluidos.concat(
          <div key={element.id} className='service'>
            <div className='background color-dinamico-fondo'>
              <i className={`${element.itemProducto.valor}`} />
            </div>
            <div className='service-label'>
              {element.valor}
            </div>
          </div>,
        );
        break;
      case 'servicios-especiales':
        elements.serviciosEspeciales = elements.serviciosEspeciales.concat(
          <div key={element.id} className='service'>
            <div className='background color-dinamico-fondo'>
              <i className={`${element.itemProducto.valor}`} />
            </div>
            <div className='service-label'>
              {element.valor}
            </div>
          </div>,
        );
        break;
      case 'servicios':
        elements.servicios = elements.servicios.concat(
          <div key={element.id} className='service'>
            <div className='background color-dinamico-fondo'>
              <i className={`${element.itemProducto.valor}`} />
            </div>
            <div className='service-label'>
              {element.valor}
            </div>
          </div>,
        );
        break;
      case 'ingresos':
        elements.ingresos = elements.ingresos.concat(
          <div key={element.id} className='service'>
            <div className='service-label'>
              <i className='fa fa-clock-o' />
              {' '}
              {element.valor}
            </div>
          </div>,
        );
        break;
      case 'info-general-por-items':
        elements.infoGeneralItems = elements.infoGeneralItems.concat(
          <div key={element.id} className='service'>
            <div className='background color-dinamico-fondo'>
              <i className={`${element.itemProducto.valor}`} />
            </div>
            <div className='service-label'>
              {element.valor}
            </div>
          </div>,
        );
        break;
      case 'info-general-texto':
        elements.infoGeneralITexto = elements.infoGeneralITexto.concat(
          <div key={element.id} className='service'>
            <div className='service-label'>
              <b>-</b>
              {' '}
              {element.valor}
            </div>
          </div>,
        );
        break;
      case 'ubicacion':
        elements.ubicacion[element.itemProductro.valor] = element.valor;
        break;
      case 'politicas-de-cancelacion':
        elements.politicasDeCancelacion = elements.politicasDeCancelacion.concat(
          <div key={element.id} className='service'>
            <div className='background color-dinamico-fondo'>
              <i className={`${element.itemProducto.valor}`} />
            </div>
            <div className='service-label'>
              {element.valor}
            </div>
          </div>,
        );
        break;
    }
  });
  return elements;
}

const Detalle = (props) => {
  const { data, additionalInfo, voucherInfo } = props;
  if (!data) {
    return createSkeleton();
  }
  const { producto } = data;
  const elements = createElement(additionalInfo);

  const listProductsUrl = `${process.env.RAZZLE_URL_PATH}/open-voucher/productos/${voucherInfo.tipoVoucher.id}/${voucherInfo.usoVoucher.id}`;
  const isValid = (prop) => prop && prop !== '';
  return (
    <div className='details-additional'>
      <div className='top'>
        <h1 className='top-name'>{producto.nombre}</h1>
        {producto.extras && producto.extras !== '' && (<p className='extra'>{producto.extras}</p>)}
        <p className='description'>{producto.descripcion}</p>
      </div>
      <div className='top-panel container-seccion'>
        <div className='row'>
          <div className='col-md-7'>
            <img
              className='slider'
              alt={producto.nombre}
              src={producto.imagenUrl}
              style={{
                display: 'inline-block',
                height: 300,
                width: '100%',
                objectFit: 'cover',
                justifyContent: 'center',
                alignItems: 'center',
                background: '#8d8d8d',
                color: '#fff',
              }}
            />
            <div className='clearfix' />
          </div>
          <div className='col-md-5'>
            <div className='basic-info'>
              <div className='elementes-container'>
                {/* <div className="sub-title">Tipo de producto</div> */}
                <div className='title-principal'>
                  Producto incluido en open voucher
                  {' '}
                  <br />
                  <h3 className='voucher-name'>{voucherInfo.tipoVoucher.descripcion}</h3>
                </div>
                <div className='info'>Quieres ver más productos?</div>
                <a className='action-list-products color-dinamico-fondo' href={listProductsUrl}>
                  Ver más productos
                </a>
              </div>
            </div>
            <div className='clearfix' />
          </div>
        </div>
      </div>
      {elements.serviciosIncluidos.length > 0 && (
        <>
          <h3 className='seccion-title'>Este producto incluye</h3>
          <div className='services-container items-icon-label container-seccion'>
            {elements.serviciosIncluidos}
          </div>
        </>
      )}
      {elements.serviciosEspeciales.length > 0 && (
        <>
          <h3 className='seccion-title'>Este producto tiene servicios especiales</h3>
          <div className='special-service-container items-icon-label container-seccion'>
            <div className='row'>
              {elements.serviciosEspeciales.map((elementDom, index) => (
                <div key={index} className='col-md-4'>
                  {elementDom}
                </div>
              ))}
            </div>
          </div>
        </>
      )}
      {elements.servicios.length > 0 && (
        <>
          <h3 className='seccion-title'>Servicios</h3>
          <div className='services-container items-icon-label container-seccion'>
            {elements.servicios}
          </div>
        </>
      )}
      {isValid(producto.longitud) && isValid(producto.latitud) && (
        <>
          <h3 className='seccion-title'>Ubicación</h3>
          <p className='descripcion-ubicacion'>
            {data.producto.direccion}
            {isValid(data.producto.localidad) && `, ${data.producto.localidad}` }
            {isValid(data.producto.provincia) && `, ${data.producto.provincia}` }
            {isValid(data.producto.pais) && `, ${data.producto.pais}` }
          </p>
          <div className='map-container container-seccion'>
            <GMapSimpleMarker
              longitud={data.producto.longitud}
              latitud={data.producto.latitud}
              markerName={data.producto.nombre}
              gMapStyle={[
                {
                  'featureType': 'poi.business',
                  'stylers': [
                    {
                      'visibility': 'off',
                    },
                  ],
                },
              ]}
            />
          </div>
        </>
      )}

      {elements.infoGeneralItems.length > 0 && (
        <>
          <h3 className='seccion-title'>Información general</h3>
          <div className='general-info-container items-icon-label container-seccion'>
            {elements.infoGeneralItems}
          </div>
        </>
      )}
      {elements.ingresos.length > 0 && (
        <>
          <h3 className='seccion-title'>Horarios</h3>
          <div className='general-info-container items-icon-label container-seccion'>
            <div className='row'>
              {elements.ingresos.map((elementDom, index) => (
                <div key={index} className='col-md-4'>
                  {elementDom}
                </div>
              ))}
            </div>
          </div>
        </>
      )}
      {elements.infoGeneralITexto.length > 0 && (
        <>
          <h3 className='seccion-title'>Otra información</h3>
          <div className='others-info-container container-seccion'>
            <ul className='with-style'>
              {elements.infoGeneralITexto}
            </ul>
          </div>
        </>
      )}
      {elements.condicionesUso.length > 0 && (
        <>
          <h3 className='seccion-title'>Condiciones uso</h3>
          <div className='services-container items-icon-label container-seccion'>
            {elements.condicionesUso}
          </div>
        </>
      )}
      {elements.politicasDeCancelacion.length > 0 && (
        <>
          <h3 className='seccion-title'>Políticas de cancelación</h3>
          <div className='services-container items-icon-label container-seccion'>
            {elements.politicasDeCancelacion}
          </div>
        </>
      )}
    </div>
  );
};

export default Detalle;
